"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var in_dom_1 = require("./in-dom");
/* https://github.com/component/raf */
var prev = new Date().getTime();
function fallback(fn) {
    var curr = new Date().getTime();
    var ms = Math.max(0, 16 - (curr - prev));
    var req = setTimeout(fn, ms);
    prev = curr;
    return req;
}
var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
var clearTimeout = 'clearTimeout';
var raf = fallback;
var getKey = function (vendor, k) { return vendor + (!vendor ? k : (k[0].toUpperCase() + k.substr(1))) + 'AnimationFrame'; };
if (in_dom_1.inDOM) {
    vendors.some(function (vendor) {
        var rafKey = getKey(vendor, 'request');
        if (rafKey in window) {
            clearTimeout = getKey(vendor, 'cancel');
            raf = function (cb) { return window[rafKey](cb); };
            return true;
        }
        return false;
    });
}
function requestAnimationFrame(cb) {
    return raf(cb);
}
exports.requestAnimationFrame = requestAnimationFrame;
// eslint-disable-next-line @typescript-eslint/no-namespace
(function (requestAnimationFrame) {
    requestAnimationFrame.cancel = function (id) {
        return window[clearTimeout](id);
    };
})(requestAnimationFrame || (requestAnimationFrame = {}));
exports.requestAnimationFrame = requestAnimationFrame;
